<div *ngIf="!reportData">
    <div class="loader is-active padding-leader-3 padding-trailer-3">
        <div class="loader-bars"></div>
        <div class="loader-text">Loading...</div>
    </div>
</div>
<div class="alert alert-red is-active container" *ngIf="error">
    {{ errorMessage }}
</div>
<div class="bootstrap-wrapper">
    <div class=" grid-container" *ngIf="reportData" id="onemap-report">
        <div class="reportSectionContainer">
            <div class="reportSectionHeader">
                <label>Detail Bridge Report</label>
            </div>
            <div class="reportSectionContent container">
                <div class="row">
                    <div class="col-xs-12">
                        <label>ID:&nbsp;</label>{{ reportData.bridge.bridge_id }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12">
                        <span class="legal-note">
                            <label>NOTE:</label>This document contains inspection information and may not be used in legal actions or proceedings against
                            the bridge owner. (Reference 65 P.S. Sec 66.1 et sep., 75 pa. C.S. Sec 3754 and 23 U.S.C. Sec 409.)
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="reportSectionContainer">
            <div class="reportSectionHeader">
                <label>Location</label>
            </div>
            <div class="reportSectionContent container">
                <div class="row">
                    <div class="col-xs-6">
                        <label>County:&nbsp;</label>{{ reportData.bridge.cty_code }}
                    </div>
                    <div class="col-xs-6">
                        <label>Route:&nbsp;</label>{{ reportData.bridge.st_rt_no }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6">
                        <label>Juris:&nbsp;</label>{{ reportData.bridge.juris }}
                    </div>
                    <div class="col-xs-6">
                        <label>Location Description:&nbsp;</label>{{ reportData.bridge.location }}
                    </div>
                </div>
            </div>
        </div>
        <div class="reportSectionContainer">
            <div class="reportSectionHeader">
                <label>Identification</label>
            </div>
            <div class="reportSectionContent container">
                <div class="row">
                    <div class="col-xs-6">
                        <label>Structure Number:&nbsp;</label>{{ reportData.bridge.brkey }}
                    </div>
                    <div class="col-xs-6">
                        <label>Location:&nbsp;</label>{{ reportData.bridge.location }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6">
                        <label>Rte.(on/under):&nbsp;</label>{{ reportData.bridge.on_under }}
                    </div>
                    <div class="col-xs-6">
                        <label>Rte. Signing Prefix:&nbsp;</label>{{ reportData.bridge.kind_hwy }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6">
                        <label>Level of Service:&nbsp;</label>{{ reportData.bridge.levl_srvc }}
                    </div>
                    <div class="col-xs-6">
                        <label>Rte. Number:&nbsp;</label>{{ reportData.bridge.st_rt_no }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6">
                        <label>Directional Suffix:&nbsp;</label>{{ reportData.bridge.dirsuffix }}
                    </div>
                    <div class="col-xs-6">
                        <label>% Responsibility:&nbsp;</label>{{ reportData.bridge.bb_pct }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6">
                        <label>SHD District:&nbsp;</label>{{ reportData.bridge.district }}
                    </div>
                    <div class="col-xs-6">
                        <label>County Code:&nbsp;</label>{{ reportData.bridge.cty_code }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6">
                        <label>Place Code:&nbsp;</label>{{ reportData.bridge.placecode }}
                    </div>
                    <div class="col-xs-6">
                        <label>Mile Point:&nbsp;</label>{{ reportData.bridge.kmpost }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6">
                        <label>Feature Intersected:&nbsp;</label>{{ reportData.bridge.featint }}
                    </div>
                    <div class="col-xs-6">
                        <label>Facility Carried:&nbsp;</label>{{ reportData.bridge.facility }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6">
                        <label>Latitude:&nbsp;</label>{{ reportData.bridge.dec_lat }}
                    </div>
                    <div class="col-xs-6">
                        <label>Longitude:&nbsp;</label>{{ reportData.bridge.dec_long }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6">
                        <label>Border Bridge Code:&nbsp;</label>{{ reportData.bridge.nstatecode }}
                    </div>
                    <div class="col-xs-6">
                        <label>Border Bridge Number:&nbsp;</label>{{ reportData.bridge.bb_bridgeid }}
                    </div>
                </div>
            </div>
        </div>
        <div class="reportSectionContainer">
            <div class="reportSectionHeader">
                <label>Structure Type &amp; Materials</label>
            </div>
            <div class="reportSectionContent container">
                <div class="row">
                    <div class="col-xs-6">
                        <label>Number of Approach Spans:&nbsp;</label>{{ reportData.bridge.appspans }}
                    </div>
                    <div class="col-xs-6">
                        <label>Number of Spans Main Unit:&nbsp;</label>{{ reportData.bridge.mainspans }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6">
                        <label>Deck Type:&nbsp;</label>{{ reportData.bridge.dkstructyp }}
                    </div>
                    <div class="col-xs-6">
                        <label>Wearing Surface:&nbsp;</label>{{ reportData.bridge.dksurftype }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6">
                        <label>Membrane:&nbsp;</label>{{ reportData.bridge.dkmembtype }}
                    </div>
                    <div class="col-xs-6">
                        <label>Deck Protection:&nbsp;</label>{{ reportData.bridge.dkprotect }}
                    </div>
                </div>
            </div>
        </div>
        <div class="reportSectionContainer">
            <div class="reportSectionHeader">
                <label>Age &amp; Service</label>
            </div>
            <div class="reportSectionContent container">
                <div class="row">
                    <div class="col-xs-6">
                        <label>Year Built:&nbsp;</label>{{ reportData.bridge.yearbuilt }}
                    </div>
                    <div class="col-xs-6">
                        <label>Year Reconstructed:&nbsp;</label>{{ reportData.bridge.yearrecon }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6">
                        <label>Type of Service On:&nbsp;</label>{{ reportData.bridge.servtypon }}
                    </div>
                    <div class="col-xs-6">
                        <label>Type of Service Under:&nbsp;</label>{{ reportData.bridge.servtypund }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6">
                        <label>Lanes On:&nbsp;</label>{{ reportData.bridge.lanes }}
                    </div>
                    <div class="col-xs-6">
                        <label>Lanes Under:&nbsp;</label>{{ reportData.bridge.sumlanes }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6">
                        <label>Detour Length:&nbsp;</label>{{ reportData.bridge.bypasslen }}
                    </div>
                    <div class="col-xs-6">
                        <label>Year of ADT:&nbsp;</label>{{ reportData.bridge.adtyear }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6">
                        <label>ADT:&nbsp;</label>{{ reportData.bridge.adttotal }}
                    </div>
                    <div class="col-xs-6">
                        <label>Truck ADT:&nbsp;</label>{{ reportData.bridge.truckpct }}
                    </div>
                </div>
            </div>
        </div>
        <div class="reportSectionContainer">
            <div class="reportSectionHeader">
                <label>Geometric Data</label>
            </div>
            <div class="reportSectionContent container">
                <div class="row">
                    <div class="col-xs-6">
                        <label>Length Max Span:&nbsp;</label>{{ reportData.bridge.maxspan }}
                    </div>
                    <div class="col-xs-6">
                        <label>Structure Length:&nbsp;</label>{{ reportData.bridge.length }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6">
                        <label>Curb/Sdwlk Width L:&nbsp;</label>{{ reportData.bridge.lftcurbsw }}
                    </div>
                    <div class="col-xs-6">
                        <label>Curb/Sdwlk Width R:&nbsp;</label>{{ reportData.bridge.rtcurbsw }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6">
                        <label>Width Curb to Curb:&nbsp;</label>{{ reportData.bridge.roadwidth }}
                    </div>
                    <div class="col-xs-6">
                        <label>Width Out to Out:&nbsp;</label>{{ reportData.bridge.deckwidth }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6">
                        <label>Approach Roadway w/ Shoulders:&nbsp;</label>{{ reportData.bridge.aroadwidth }}
                    </div>
                    <div class="col-xs-6">
                        <label>Median:&nbsp;</label>{{ reportData.bridge.bridgemed }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6">
                        <label>Deck Area:&nbsp;</label>{{ reportData.bridge.deck_area }}
                    </div>
                    <div class="col-xs-6">
                        <label>Skew:&nbsp;</label>{{ reportData.bridge.skew }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6">
                        <label>Structure Flared:&nbsp;</label>{{ reportData.bridge.strflared }}
                    </div>
                    <div class="col-xs-6">
                        <label>Horiz. Clearance:&nbsp;</label>{{ reportData.bridge.hclrinv }}
                    </div>
                </div>
            </div>
        </div>
        <div class="reportSectionContainer">
            <div class="reportSectionHeader">
                <label>Inspection</label>
            </div>
            <div class="reportSectionContent container">
                <div class="row">
                    <div class="col-xs-6">
                        <label>Frequency:&nbsp;</label>{{ reportData.bridge.brinspfreq }}
                    </div>
                    <div class="col-xs-6">
                        <label>Inspection Date:&nbsp;</label><span *ngIf="reportData.bridge.inspdate">{{ reportData.bridge.inspdate.substring(4,6) }}/{{ reportData.bridge.inspdate.substring(6) }}/{{ reportData.bridge.inspdate.substring(0,4) }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="reportSectionContainer">
            <div class="reportSectionHeader">
                <label>Classification</label>
            </div>
            <div class="reportSectionContent container">
                <div class="row">
                    <div class="col-xs-6">
                        <label>Defense Highway:&nbsp;</label>{{ reportData.bridge.defhwy }}
                    </div>
                    <div class="col-xs-6">
                        <label>Parallel Structure:&nbsp;</label>{{ reportData.bridge.paralstruc }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6">
                        <label>Direction of Traffic:&nbsp;</label>{{ reportData.bridge.trafficdir }}
                    </div>
                    <div class="col-xs-6">
                        <label>Temporary Structure:&nbsp;</label>{{ reportData.bridge.tempstruc }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6">
                        <label>Highway System:&nbsp;</label>{{ reportData.bridge.nhs_ind }}
                    </div>
                    <div class="col-xs-6">
                        <label>NBIS Length:&nbsp;</label>{{ reportData.bridge.nbislen }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6">
                        <label>Toll Facility:&nbsp;</label>{{ reportData.bridge.tollfac }}
                    </div>
                    <div class="col-xs-6">
                        <label>Functional Class:&nbsp;</label>{{ reportData.bridge.funcclass }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6">
                        <label>Owner:&nbsp;</label>{{ reportData.bridge.owner }}
                    </div>
                    <div class="col-xs-6">
                        <label>Custodian:&nbsp;</label>{{ reportData.bridge.custodian }}
                    </div>
                </div>
            </div>
        </div>
        <div class="reportSectionContainer">
            <div class="reportSectionHeader">
                <label>Condition</label>
            </div>
            <div class="reportSectionContent container">
                <div class="row">
                    <div class="col-xs-6">
                        <label>Deck:&nbsp;</label>{{ reportData.bridge.dkrating }}
                    </div>
                    <div class="col-xs-6">
                        <label>Super:&nbsp;</label>{{ reportData.bridge.suprating }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6">
                        <label>Sub:&nbsp;</label>{{ reportData.bridge.subrating }}
                    </div>
                    <div class="col-xs-6">
                        <label>Culvert:&nbsp;</label>{{ reportData.bridge.culvrating }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6">
                        <label>Channel/Channel Protection:&nbsp;</label>{{ reportData.bridge.chanrating }}
                    </div>
                </div>
            </div>
        </div>
        <div class="reportSectionContainer">
            <div class="reportSectionHeader">
                <label>Load Rating &amp; Posting</label>
            </div>
            <div class="reportSectionContent container">
                <div class="row">
                    <div class="col-xs-6">
                        <label>Posting Status:&nbsp;</label>{{ reportData.bridge.post_status }}
                    </div>
                </div>
            </div>
        </div>
        <div class="reportSectionContainer">
            <div class="reportSectionHeader">
                <label>Appraisal</label>
            </div>
            <div class="reportSectionContent container">
                <div class="row">
                    <div class="col-xs-6">
                        <label>Bridge Rail:&nbsp;</label>{{ reportData.bridge.railrating }}
                    </div>
                    <div class="col-xs-6">
                        <label>Approach Rail:&nbsp;</label>{{ reportData.bridge.arailratin }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6">
                        <label>Transition:&nbsp;</label>{{ reportData.bridge.transratin }}
                    </div>
                    <div class="col-xs-6">
                        <label>Approach Rail Ends:&nbsp;</label>{{ reportData.bridge.aendrating }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6">
                        <label>Under Clearance Vertical &amp; Horizontal:&nbsp;</label>{{ reportData.bridge.underclr }}
                    </div>
                    <div class="col-xs-6">
                        <label>Deck Geometry:&nbsp;</label>{{ reportData.bridge.deckgeom }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6">
                        <label>Waterway Adequacy:&nbsp;</label>{{ reportData.bridge.wateradeq }}
                    </div>
                    <div class="col-xs-6">
                        <label>Approach Alignment:&nbsp;</label>{{ reportData.bridge.appralign }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6">
                        <label>Scour Critical:&nbsp;</label>{{ reportData.bridge.scourcrit }}
                    </div>
                </div>
            </div>
        </div>
        <div class="reportSectionContainer">
            <div class="reportSectionHeader">
                <label>Proposed Improvements</label>
            </div>
            <div class="reportSectionContent container">
                <div class="row">
                    <div class="col-xs-6">
                        <label>Bridge Cost:&nbsp;</label>{{ reportData.bridge.nbiimpcost }}
                    </div>
                    <div class="col-xs-6">
                        <label>Type of Work:&nbsp;</label>{{ reportData.bridge.propwork }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6">
                        <label>Roadway Cost:&nbsp;</label>{{ reportData.bridge.nbirwcost }}
                    </div>
                    <div class="col-xs-6">
                        <label>Length of Improvement:&nbsp;</label>{{ reportData.bridge.implen }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6">
                        <label>Total Cost:&nbsp;</label>{{ reportData.bridge.nbitotcost }}
                    </div>
                    <div class="col-xs-6">
                        <label>Future ADT:&nbsp;</label>{{ reportData.bridge.adtfuture }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6">
                        <label>Year of Cost Estimate:&nbsp;</label>{{ reportData.bridge.nbiyrcost }}
                    </div>
                    <div class="col-xs-6">
                        <label>Year of Future ADT:&nbsp;</label>{{ reportData.bridge.adtfutyear }}
                    </div>
                </div>
            </div>
        </div>
        <div class="reportSectionContainer">
            <div class="reportSectionHeader">
                <label>Navigation Data</label>
            </div>
            <div class="reportSectionContent container">
                <div class="row">
                    <div class="col-xs-6">
                        <label>Navigation Control:&nbsp;</label>{{ reportData.bridge.navcntrol }}
                    </div>
                    <div class="col-xs-6">
                        <label>Vertical Clearance:&nbsp;</label>{{ reportData.bridge.vclrover }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6">
                        <label>Horizontal Clearance:&nbsp;</label>{{ reportData.bridge.hclrinv }}
                    </div>
                    <div class="col-xs-6">
                        <label>Pier Protection:&nbsp;</label>{{ reportData.bridge.pierprot }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6">
                        <label>Lift Bridge Vertical Clearance:&nbsp;</label>{{ reportData.bridge.lftbrnavcl }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
